import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Simulador {
  public static async get(id: number): Promise<CotacaoResponse> {
    const response = await Simulador.instance
      .get<CotacaoResponse>('/cotacao.php', { params: { id } });
    return response.data;
  }

  public static async create(data: {}): Promise<CriarCotacaoResponse> {
    const response = await Simulador.instance
      .post<CriarCotacaoResponse>('/cotacao.php', data);
    return response.data;
  }

  public static async update(data: {}): Promise<AtualizarCotacaoResponse> {
    const response = await Simulador.instance
      .put<AtualizarCotacaoResponse>('/cotacao.php', data);
    return response.data;
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
